import { load } from "recaptcha-v3"
import { withUrlPrefix } from '@/js/helpers';

const SITE_KEY = document.querySelector('meta[name="recaptcha-site-key"]')?.content;

const initRecaptcha = async () => {
    // 本番は /bunjo 配下で配信されるため pathname は /bunjo/componentlist になる。
    // 接頭辞を足さずに比較すると、このガードが本番だけ常に不一致になって効かない
    if (window.location.pathname.startsWith(withUrlPrefix('/componentlist'))) return;
    const forms = document.querySelectorAll("form[data-recaptcha-action]");
    if (!SITE_KEY || forms.length === 0) return;

    const recaptcha = await load(SITE_KEY);

    forms.forEach((form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // 二重送信防止
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton?.disabled) return;
            if (submitButton) submitButton.disabled = true;

            try {
                const token = await recaptcha.execute(form.dataset.recaptchaAction);
                form.querySelector('input[name="g-recaptcha-response"]').value = token;
                form.submit();
            } catch (err) {
                // recaptcha API への通信失敗時はトークン未設定のままサーバへ送信し、
                // サーバ側のバリデーションエラーで既存のエラー表示エリアに出す
                console.error('reCAPTCHA failed:', err);
                form.submit();
            }
        });
    });
}

export default initRecaptcha;
